import { watch, nextTick, onBeforeUnmount } from 'vue'
import { useSelectedRowNodes } from './selected-row-nodes'

// Adds a checkbox counter to an existing header checkbox component.
// Assumes one per table.
export const useCheckboxCounter = ({ gridApi }) => {
  const { totalSelectedRowNodes } = useSelectedRowNodes({ gridApi })

  const onSelectionChanged = async () => {
    await nextTick()

    const checkHeader = document.querySelector('.ag-header-select-all:not(.ag-hidden)')

    if (!checkHeader) {
      return
    }

    const counterContainer = checkHeader.querySelector('#total-selections')

    if (totalSelectedRowNodes.value === 0) {
      counterContainer?.remove()
      return
    }

    if (checkHeader && !counterContainer) {
      const counterContainer = document.createElement('span')
      counterContainer.id = 'total-selections'

      const counterSpan = document.createElement('span')
      counterSpan.classList.add('counter-span')
      counterSpan.innerHTML = String(totalSelectedRowNodes.value)

      counterContainer.appendChild(counterSpan)
      checkHeader.appendChild(counterContainer)
    } else {
      counterContainer.querySelector('.counter-span').innerHTML = String(totalSelectedRowNodes.value)
    }
  }

  watch(
    gridApi,
    async () => {
      await nextTick()

      const cols = gridApi.value.getColumnDefs()
      const checkboxIndex = cols.findIndex((col) => col.field === 'checkbox')

      if (checkboxIndex === -1) {
        return
      }

      // AG grid destroys the header checkbox component when it's out of view on screen.
      // This acts as a hook to let us re-render the checkbox counter when it comes back in to view.
      cols[checkboxIndex].headerValueGetter = () => {
        onSelectionChanged()
        return ''
      }

      gridApi.value.setGridOption('columnDefs', cols)
      gridApi.value.addEventListener('selectionChanged', onSelectionChanged)
    },
    { once: true }
  )

  onBeforeUnmount(() => {
    gridApi.value.removeEventListener('selectionChanged', onSelectionChanged)
  })
}

// Dynamically adds a checkbox column to the table.
export const useCheckBoxColumn = ({ gridApi }) => {
  const checkBoxCol = {
    field: 'checkbox',
    headerName: '',
    headerCheckboxSelection: true,
    checkboxSelection: true,
    resizable: false,
    suppressSizeToFit: true,
    width: 98,
    minWidth: 98,
    sortable: false
  }

  watch(
    gridApi,
    () => {
      const cols = gridApi.value.getColumnDefs()

      // Client side tables should use the filtered only header checkbox selection.
      if (gridApi.value.getGridOption('rowModelType') !== 'serverSide') {
        checkBoxCol.headerCheckboxSelectionFilteredOnly = true
      }

      const newCols = [checkBoxCol, ...cols]
      gridApi.value.setGridOption('columnDefs', newCols)
    },
    { once: true }
  )
}
